<template>
  <div class="d-flex flex-column align-center">
    <div class="fill-width">
      <div class="d-flex">
        <CasualAutocomplete :session="session" class="mb-2 remaining-space" />
        <div style="min-width: 6px"></div>
        <div class="mt-5px">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                @click="openCasualsPhoneBook"
                x-small
                outlined
                v-on="on"
                :class="[
                  isDarkMode ? 'white--text' : 'grey--text text--darken-2',
                ]"
                fab
              >
                <v-icon>mdi-book-open-variant</v-icon>
              </v-btn>
            </template>
            <span>{{ $t('Open guests phone book') }}</span>
          </v-tooltip>
        </div>
      </div>
    </div>

    <CasualsPhoneBook
      v-if="isShowCasualsPhoneBook"
      :closeDialog="() => (isShowCasualsPhoneBook = false)"
      :session="session"
    />
  </div>
</template>

<script>
import Button from '@/components/BaseComponents/Button/Button.vue'
import CasualsPhoneBook from '@/components/WebsiteInterface/CommonComponents/CasualSend/Children/CasualsPhoneBook/CasualsPhoneBook.vue'
import CasualAutocomplete from '@/components/WebsiteInterface/CommonComponents/CasualSend/Children/CasualAutocomplete/CasualAutocomplete.vue'
import Subject from '@/components/WebsiteInterface/CommonComponents/UploadingDetailsFields/Childrens/Subject/Subject.vue'
import Message from '@/components/WebsiteInterface/CommonComponents/UploadingDetailsFields/Childrens/Message/Message.vue'
import FileDirButtons from '@/components/WebsiteInterface/CommonComponents/FileDirButtons/FileDirButtons.vue'
import DynamicFields from '@/components/CommonComponents/DynamicFields/DynamicFields.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'CasualRecipients',
  data() {
    return {
      isShowCasualsPhoneBook: false,
    }
  },
  components: {
    Button,
    CasualsPhoneBook,
    CasualAutocomplete,
    Subject,
    Message,
    FileDirButtons,
    DynamicFields,
  },
  props: {
    session: Object,
  },
  methods: {
    openCasualsPhoneBook() {
      this.isShowCasualsPhoneBook = true
    },
  },
  computed: {
    ...mapGetters(['loggedUser', 'isDarkMode']),
  },
}
</script>
<style scoped>
.mt-5px {
  margin-top: 5px;
}
</style>
